export function calculateLetterSpacing(
  tracking: number,
  fontSize: number
): string {
  return `${(fontSize * (tracking / 100)) / 10}px`;
}
